"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// General errors
var ERROR_INVALID_REQUEST = exports.ERROR_INVALID_REQUEST = 4051;

// Signup Errors
var ERROR_SIGNUP_EXISTING_EMAIL = exports.ERROR_SIGNUP_EXISTING_EMAIL = 4034;
var ERROR_SIGNUP_FB_EXISTING_ACCOUNT = exports.ERROR_SIGNUP_FB_EXISTING_ACCOUNT = 4033;
var ERROR_SIGNUP_FB_MISSING_EMAIL = exports.ERROR_SIGNUP_FB_MISSING_EMAIL = 40331;

// Account errors
var ERROR_CHANGE_PASSWORD_INCORRECT = exports.ERROR_CHANGE_PASSWORD_INCORRECT = 4045;

// Payment Errors
var ERROR_PAYMENT = exports.ERROR_PAYMENT = 4301;

// Reservation Errors
var ERROR_RESERVATION_NO_SPOTS = exports.ERROR_RESERVATION_NO_SPOTS = 5011;
var ERROR_RESERVATION_WINDOW_CLOSED = exports.ERROR_RESERVATION_WINDOW_CLOSED = 5421;

var ERROR_INVALID_PASSWORD_RESET_TOKEN = exports.ERROR_INVALID_PASSWORD_RESET_TOKEN = 4037;